import { useMemo } from "react";
import { usePlanComparisonData } from "../../../hooks/usePlanComparisonData";
import { computeVisualDiff } from "../../../utils/computeVisualDiff";
import type { UseVisualDiff } from "./types";

export const useVisualDiff: UseVisualDiff = ({
  beforePlanRecord,
  afterPlanRecord,
}) => {
  const { beforePlan, afterPlan, isLoading, isError } = usePlanComparisonData({
    beforePlanRecord,
    afterPlanRecord,
  });

  const visualDiff = useMemo(() => {
    if (beforePlan === null || afterPlan === null) return null;
    return computeVisualDiff({ beforePlan, afterPlan });
  }, [beforePlan, afterPlan]);

  return { afterPlan, visualDiff, isLoading, isError };
};
